export default __webpack_public_path__ + "static/media/platinumClub.11b9c776.png";